import { useState, type FormEvent } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { authClient } from "@/api/auth";
import { AuthLayout } from "@/components/layout/AuthLayout";
import { TextInput } from "@/components/forms/TextInput";
import { Button } from "@/components/primitives/Button";
import { useSession } from "@/session/SessionProvider";
import { useToast } from "@/components/feedback/Toast";

export default function Login() {
	const { isAuthed, isLoading, refresh } = useSession();
	const navigate = useNavigate();
	const { toast } = useToast();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [busy, setBusy] = useState(false);
	const [error, setError] = useState<string | null>(null);

	if (!isLoading && isAuthed) return <Navigate to="/app" replace />;

	async function onSubmit(e: FormEvent) {
		e.preventDefault();
		setBusy(true);
		setError(null);
		const { error: err } = await authClient.signIn.email({ email, password });
		setBusy(false);
		if (err) {
			setError(err.message ?? "Anmeldung fehlgeschlagen");
			return;
		}
		await refresh();
		toast("Angemeldet", "success");
		navigate("/app", { replace: true });
	}

	return (
		<AuthLayout title="Anmelden" subtitle="E-Mail und Passwort — oder dein Lesezeichen-Zugangslink.">
			<form className="flex flex-col gap-4" onSubmit={onSubmit}>
				<TextInput
					label="E-Mail"
					type="email"
					name="email"
					autoComplete="email"
					required
					value={email}
					onChange={(e) => setEmail(e.target.value)}
				/>
				<TextInput
					label="Passwort"
					type="password"
					name="password"
					autoComplete="current-password"
					required
					value={password}
					onChange={(e) => setPassword(e.target.value)}
				/>
				{error ? <p className="text-sm text-rose-500">{error}</p> : null}
				<Button type="submit" disabled={busy}>
					{busy ? "…" : "Anmelden"}
				</Button>
			</form>
			<p className="mt-6 text-sm text-fg-muted">
				Registrierung nur per Einladung.{" "}
				<Link
					className="font-medium text-teal-600 hover:underline dark:text-teal-400"
					to="/register"
				>
					Mehr erfahren
				</Link>
			</p>
		</AuthLayout>
	);
}
